module.exports = __webpack_public_path__ + "img/arrow-left-circle.5c84cf50.svg";